<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  updated() {
    window.scroll(0, 0);
  },
  mounted() {
    // window.onresize = () => {
    //   if (this._isMoblie()) {
    //     console.log(window.location.href);
    //     if (window.location.href.indexOf("m_products") > -1) {
    //       return this.$router.push(
    //         window.location.href.substring(
    //           window.location.href.indexOf("m_products") - 1
    //         )
    //       );
    //     }
    //     if (window.location.href.indexOf("m_advantage") > -1) {
    //       return this.$router.push(
    //         window.location.href.substring(
    //           window.location.href.indexOf("m_advantage") - 1
    //         )
    //       );
    //     }
    //     if (window.location.href.indexOf("m_tech") > -1) {
    //       return this.$router.push(
    //         window.location.href.substring(
    //           window.location.href.indexOf("m_tech") - 1
    //         )
    //       );
    //     }
    //     if (window.location.href.indexOf("m_contentUS") > -1) {
    //       return this.$router.push(
    //         window.location.href.substring(
    //           window.location.href.indexOf("m_contentUS") - 1
    //         )
    //       );
    //     }
    //     if (window.location.href.indexOf("m_partner") > -1) {
    //       return this.$router.push(
    //         window.location.href.substring(
    //           window.location.href.indexOf("m_partner") - 1
    //         )
    //       );
    //     }
    //     this.$router.push("/m_index");
    //   } else {
    //     if (window.location.href.indexOf("techCenter") > -1) {
    //       return this.$router.push(
    //         window.location.href.substring(
    //           window.location.href.indexOf("techCenter") - 1
    //         )
    //       );
    //     }
    //     if (window.location.href.indexOf("products") > -1) {
    //       return this.$router.push(
    //         window.location.href.substring(
    //           window.location.href.indexOf("products") - 1
    //         )
    //       );
    //     }
    //     if (window.location.href.indexOf("partner") > -1) {
    //       return this.$router.push(
    //         window.location.href.substring(
    //           window.location.href.indexOf("partner") - 1
    //         )
    //       );
    //     }
    //     if (window.location.href.indexOf("advantage") > -1) {
    //       return this.$router.push(
    //         window.location.href.substring(
    //           window.location.href.indexOf("advantage") - 1
    //         )
    //       );
    //     }
    //     if (window.location.href.indexOf("contentUS") > -1) {
    //       return this.$router.push(
    //         window.location.href.substring(
    //           window.location.href.indexOf("contentUS") - 1
    //         )
    //       );
    //     }

    //     this.$router.push("/");
    //   }
    // };
    if (this._isMoblie()) {
      if (window.location.href.indexOf("m_products") > -1) {
        return this.$router.push(
          window.location.href.substring(
            window.location.href.indexOf("m_products") - 1
          )
        );
      }
      if (window.location.href.indexOf("m_advantage") > -1) {
        return this.$router.push(
          window.location.href.substring(
            window.location.href.indexOf("m_advantage") - 1
          )
        );
      }
      if (window.location.href.indexOf("m_tech") > -1) {
        return this.$router.push(
          window.location.href.substring(
            window.location.href.indexOf("m_tech") - 1
          )
        );
      }
      if (window.location.href.indexOf("m_contentUS") > -1) {
        return this.$router.push(
          window.location.href.substring(
            window.location.href.indexOf("m_contentUS") - 1
          )
        );
      }
      if (window.location.href.indexOf("m_partner") > -1) {
        return this.$router.push(
          window.location.href.substring(
            window.location.href.indexOf("m_partner") - 1
          )
        );
      }

      if (window.location.href.indexOf("techCenter") > -1) {
        return this.$router.push(
          window.location.href.substring(
            window.location.href.indexOf("techCenter") - 1
          )
        );
      }
      if (window.location.href.indexOf("products") > -1) {
        return this.$router.push(
          window.location.href.substring(
            window.location.href.indexOf("products") - 1
          )
        );
      }
      if (window.location.href.indexOf("partner") > -1) {
        return this.$router.push(
          window.location.href.substring(
            window.location.href.indexOf("partner") - 1
          )
        );
      }
      if (window.location.href.indexOf("advantage") > -1) {
        return this.$router.push(
          window.location.href.substring(
            window.location.href.indexOf("advantage") - 1
          )
        );
      }
      if (window.location.href.indexOf("contentUS") > -1) {
        return this.$router.push(
          window.location.href.substring(
            window.location.href.indexOf("contentUS") - 1
          )
        );
      }

      if (window.location.href.indexOf("post") > -1) {
        return this.$router.push(
          window.location.href.substring(
            window.location.href.indexOf("post") - 1
          )
        );
      }

      this.$router.push("/m_index");
    } else {
      if (window.location.href.indexOf("techCenter") > -1) {
        return this.$router.push(
          window.location.href.substring(
            window.location.href.indexOf("techCenter") - 1
          )
        );
      }
      if (window.location.href.indexOf("products") > -1) {
        return this.$router.push(
          window.location.href.substring(
            window.location.href.indexOf("products") - 1
          )
        );
      }
      if (window.location.href.indexOf("partner") > -1) {
        return this.$router.push(
          window.location.href.substring(
            window.location.href.indexOf("partner") - 1
          )
        );
      }
      if (window.location.href.indexOf("advantage") > -1) {
        return this.$router.push(
          window.location.href.substring(
            window.location.href.indexOf("advantage") - 1
          )
        );
      }
      if (window.location.href.indexOf("contentUS") > -1) {
        return this.$router.push(
          window.location.href.substring(
            window.location.href.indexOf("contentUS") - 1
          )
        );
      }

      if (window.location.href.indexOf("post") > -1) {
        return this.$router.push(
          window.location.href.substring(
            window.location.href.indexOf("post") - 1
          )
        );
      }

      this.$router.push("/");
    }
  },

  methods: {
    _isMoblie() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
  },
};
</script>

<style>
@import "./less/common.less";
#app {
  background: #000;
  -webkit-overflow-scrolling: touch;
  /* font-size: 100px; */
}
</style>
